import dayjs from 'dayjs';
import * as type from '../actions/types';

const initialState = {
  restaurant: {},
  id: '',
  restaurantFetching: true, // TODO what makes this different to fetching?
  fetching: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case type.SET_ACTIVE_RESTAURANT_ID:
      return {
        ...state,
        id: action.payload,
        fetching: true,
      };

    case type.SET_ACTIVE_RESTAURANT:
      return {
        ...state,
        restaurant: action.payload,
        restaurantFetching: false,
        fetching: false,
      };

    case type.FETCH_RESTAURANT_SUCCESS:
      return {
        ...state,
        restaurantFetching: true,
        fetching: true,
      };

    case type.FETCH_RESTAURANT_FAILURE:
      return {
        ...state,
        restaurantFetching: false,
        fetching: false,
      };

    case type.UPDATE_AVERAGE_ORDER_VALUE_SUCCESS:
      return {
        ...state,
        restaurant: {
          ...state.restaurant,
          averageOrderValue: action.payload.data.averageOrderValue,
        },
      };

    case type.UPDATE_AVERAGE_BOOKING_VALUE_SUCCESS:
      return {
        ...state,
        restaurant: {
          ...state.restaurant,
          averageBookingValue: action.payload.data.averageBookingValue,
        },
      };

    case type.OBEE_ONBOARD_SUCCESS: {
      const { obeeEnabled, obeeGoLiveDate, premium } = action.payload;
      return {
        ...state,
        restaurant: { ...state.restaurant, obeeEnabled, obeeGoLiveDate, premium },
      };
    }

    case type.CLOSE_RESTAURANT_SUCCESS:
    case type.REOPEN_RESTAURANT_SUCCESS: {
      const today = dayjs().startOf('day');

      const currentClosures = (action.payload?.data?.closures || []).filter((closure) =>
        today.isBetween(dayjs(closure.startDate), dayjs(closure.endDate), 'day', '[]'),
      );

      // The restaurant is _currently_ closed, but will be back online tomorrow
      const closedEarlyToday =
        (action.payload?.data?.closeDate &&
          dayjs(action.payload?.data?.closeDate).isSame(today, 'day')) ||
        currentClosures.some(
          (closure) => dayjs(closure.endDate).startOf('day').diff(today, 'day') <= 1,
        );

      // Restaurant is paused for any reason
      const paused = closedEarlyToday || currentClosures.length > 0;

      // Restaurant is paused due to churn (paused but not closed early)
      const closurePause = paused && !closedEarlyToday;

      return {
        ...state,
        restaurant: {
          ...state.restaurant,
          closures: action.payload.data?.closures,
          closedEarlyToday,
          paused,
          closurePause,
        },
      };
    }

    case type.UPDATE_FOOD_COST_PERCENT_PENDING: {
      return {
        ...state,
        restaurant: {
          ...state.restaurant,
          foodCostPercent: action.payload.data?.foodCostPercent ?? 30,
        },
      };
    }

    case type.UPDATE_FOOD_COST_PERCENT_SUCCESS: {
      return {
        ...state,
        restaurant: {
          ...state.restaurant,
          foodCostPercent: action.payload.data?.foodCostPercent ?? 30,
        },
      };
    }

    case type.SAVE_RESTAURANT_PAUSE_SUCCESS: {
      // If user paused the venue
      if (action.payload.data?.offerAccepted === 'false' && !action.payload?.hasDebt) {
        return {
          ...state,
          restaurant: {
            ...state.restaurant,
            paused: true,
            closurePause: true,
          },
        };
      }

      return { ...state };
    }

    // Reactivate a paused restaurant
    case type.REACTIVATE_RESTAURANT_PAUSE_SUCCESS: {
      // If unpause was successful
      if (action.payload?.data?.result === 'success') {
        return {
          ...state,
          restaurant: {
            ...state.restaurant,
            paused: false,
            closurePause: false,
          },
        };
      }
      return { ...state };
    }

    default:
      return state;
  }
};
